import {Component, Inject, Input, OnInit} from '@angular/core';
import {NbMenuComponent} from '@nebular/theme/components/menu/menu.component';
import {NB_WINDOW, NbMenuItem} from '@nebular/theme';
import {NbMenuInternalService} from '@nebular/theme/components/menu/menu.service';
import {Router} from '@angular/router';
import {MENU_ITEMS} from '../../pages/pages-menu';

@Component({
    styleUrls: ['./menu.component.scss'],
    selector: 'ngx-menu',
    template: `
        <ul class="menu-items">
            <ng-container *ngFor="let item of items">
                <li nbMenuItem *ngIf="!item.hidden"
                    [menuItem]="item"
                    [class.menu-group]="item.group"
                    (hoverItem)="onHoverItem($event)"
                    (toggleSubMenu)="onToggleSubMenu($event)"
                    (selectItem)="onSelectItem($event)"
                    (itemClick)="onItemClick($event)"
                    class="menu-item">
                </li>
            </ng-container>
        </ul>
    `,
})
export class MenuComponent extends NbMenuComponent {
    @Input() items: NbMenuItem[];

    constructor(@Inject(NB_WINDOW) private window2,
                private menuInternalService2: NbMenuInternalService,
                private router2: Router) {
        super(window2, menuInternalService2, router2);
        this.items = MENU_ITEMS;
    }

}
